import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ClientService } from 'src/app/services/client.service';
import { ContextService } from 'src/app/services/context.service';

@Component({
	selector: 'app-welcome-customer-details',
	templateUrl: './customer-details.component.html',
	styleUrls: ['./customer-details.component.css']
})
export class WelcomeCustomerDetailsComponent implements OnInit {
	@ViewChild('inputCompanyName') inputCompanyName: ElementRef;
	@ViewChild('inputEmail') inputEmail: ElementRef;
	@ViewChild('inputBillingEmail') inputBillingEmail: ElementRef;
	@ViewChild('inputName') inputName: ElementRef;

	loading = false;

	form: UntypedFormGroup;

	companyNameValid: boolean = false;
	emailValid: boolean;
	billingEmailValid: boolean;
	nameValid: boolean = false;

	companyName;
	email;
	billingEmail;
	name;

	constructor(
		private fb: UntypedFormBuilder,
		private clientService: ClientService,
		private contextService: ContextService,
		private router: Router
	) { }

	ngOnInit() {
		this.initForm();
	}

	initForm() {
		this.form = this.fb.group({
			companyName: new UntypedFormControl(this.contextService.procoreUserInfo.companyName, [Validators.required]),
			email: new UntypedFormControl(this.contextService.procoreUserInfo.email, [Validators.required]),
			billingEmail: new UntypedFormControl(this.contextService.procoreUserInfo.email, [Validators.required]),
			name: new UntypedFormControl(this.contextService.procoreUserInfo.name, [Validators.required]),
		});

		this.companyNameValid = null;
		this.emailValid = null;
		this.billingEmailValid = null;
		this.nameValid = null;

		this.doCompanyNameValidation(this.contextService.procoreUserInfo.companyName);
		this.doEmailValidation(this.contextService.procoreUserInfo.email);
		this.doBillingEmailValidation(this.contextService.procoreUserInfo.email);
		this.doNameValidation(this.contextService.procoreUserInfo.name);
	}

	doCompanyNameValidation(e: any) {
		let companyNameValue = '';
		if (e.target?.value) {
			companyNameValue = e.target.value;
		} else {
			companyNameValue = e;
		}
		if (companyNameValue.length > 0) {
			this.companyNameValid = true;
		} else {
			this.companyNameValid = false;
		}
	}

	doEmailValidation(e: any) {
		let emailValue = '';
		if (e.target?.value) {
			emailValue = e.target.value;
		} else {
			emailValue = e;
		}
		const regexPattern: RegExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		if (regexPattern.test(emailValue)) {
			this.emailValid = true;
		} else {
			this.emailValid = false;
		}
	}

	doBillingEmailValidation(e: any) {
		let emailValue = '';
		if (e.target?.value) {
			emailValue = e.target.value;
		} else {
			emailValue = e;
		}
		const regexPattern: RegExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		if (regexPattern.test(emailValue)) {
			this.billingEmailValid = true;
		} else {
			this.billingEmailValid = false;
		}
	}

	doNameValidation(e: any) {
		let nameValue = '';
		if (e.target?.value) {
			nameValue = e.target.value;
		} else {
			nameValue = e;
		}
		if (nameValue.length > 0) {
			this.nameValid = true;
		} else {
			this.nameValid = false;
		}
	}

	// Retrieve or create the Stripe Customer ID based on the supplied email and company name.
	computeCustomerId() {
		this.loading = true;

		this.companyName = this.inputCompanyName.nativeElement.value;
		this.name = this.inputName.nativeElement.value;
		this.email = this.inputEmail.nativeElement.value;
		this.billingEmail = this.inputBillingEmail.nativeElement.value;

		// Perform a lookup in Stripe by email
		this.clientService.createClientCustomerId(this.billingEmail, this.companyName)
			.subscribe((customerId) => {
				console.log('DS - SET CUSTOMER ID: ' + customerId);
				this.contextService.stripeCustomerId = customerId;

				this.computeClient();
			});
	}

	// Retrieve or create the Client based on the Stripe Customer ID.
	computeClient() {
		// Create a client
		this.clientService.createClient(this.companyName, this.name, this.email, this.billingEmail, this.contextService.stripeCustomerId, this.contextService.procoreContextObject.context.company_id)
			.subscribe((client) => {
				console.log(client);
				console.log('DS - SET CLIENT: ' + client.clientId);

				this.contextService.client = client;
				this.contextService.clientDetailProcore = client.clientDetailProcore;

				this.router.navigate(['/welcome/type']);
			});
	}
}
